<template>
    <img class="gif"
         :style="data.styleRect"
         :src="`${bookInfoState.publicPath}/${props.annot.res}`"
         onerror="this.style.display='none'"
    >
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";

    const {getResizedAnnotationPos, styleAnnotationBtn} = useAnnotationHelper();

    export default {
        props: {
            annot:Object
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState} = useBookInfo();
            const { pageResizeState} = usePageResize();

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        position:"absolute"
                    }
                })
            });

            return {
                props,
                data,
                bookInfoState
            }

        }
    }

</script>


<style scoped lang="scss">


</style>